import React, { useState } from 'react';
import { Button, PopoverBody, UncontrolledPopover } from "reactstrap";

 function ReferalsFilter(props) {

    const { filter, setFilter } = props;
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");

    const toggle = () => setPopoverOpen(!popoverOpen);

    const handleFilterChange = (event) => {
        setSelectedFilter(event.target.value); 
    };

    const applyFilter = () => {
        setFilter(selectedFilter);
        toggle();
    };

    return (

        <>
            <div className="nexogic-page-flter-title-w mt-0">
                {props.isTitle &&
                    <h1 className="nexogic-page-title w-100 nexogic-page-flter-title mb-0">
                        {`My ${filter === 'SENT' ? 'Sent' : 'Received'} Referrals`}
                    </h1>
                }
                <div className='nexogic-home-filter-w'>
                    <Button
                        id="ReferralPopoverFocus"
                        type="button"
                        className="filter-btn-wrp"
                        onClick={toggle}
                    >
                        Filters <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.3594 6.5625H1.64062C1.37955 6.5625 1.12917 6.46373 0.944567 6.28791C0.759961 6.1121 0.65625 5.87364 0.65625 5.625C0.65625 5.37636 0.759961 5.1379 0.944567 4.96209C1.12917 4.78627 1.37955 4.6875 1.64062 4.6875H19.3594C19.6204 4.6875 19.8708 4.78627 20.0554 4.96209C20.24 5.1379 20.3438 5.37636 20.3438 5.625C20.3438 5.87364 20.24 6.1121 20.0554 6.28791C19.8708 6.46373 19.6204 6.5625 19.3594 6.5625ZM16.0781 10.9375H4.92188C4.6608 10.9375 4.41042 10.8387 4.22582 10.6629C4.04121 10.4871 3.9375 10.2486 3.9375 10C3.9375 9.75136 4.04121 9.5129 4.22582 9.33709C4.41042 9.16127 4.6608 9.0625 4.92188 9.0625H16.0781C16.3392 9.0625 16.5896 9.16127 16.7742 9.33709C16.9588 9.5129 17.0625 9.75136 17.0625 10C17.0625 10.2486 16.9588 10.4871 16.7742 10.6629C16.5896 10.8387 16.3392 10.9375 16.0781 10.9375ZM12.1406 15.3125H8.85938C8.5983 15.3125 8.34792 15.2137 8.16332 15.0379C7.97871 14.8621 7.875 14.6236 7.875 14.375C7.875 14.1264 7.97871 13.8879 8.16332 13.7121C8.34792 13.5363 8.5983 13.4375 8.85938 13.4375H12.1406C12.4017 13.4375 12.6521 13.5363 12.8367 13.7121C13.0213 13.8879 13.125 14.1264 13.125 14.375C13.125 14.6236 13.0213 14.8621 12.8367 15.0379C12.6521 15.2137 12.4017 15.3125 12.1406 15.3125Z" fill="#009FD7" />
                        </svg>
                    </Button>
                    <UncontrolledPopover
                        placement="bottom"
                        target="ReferralPopoverFocus"
                        trigger="legacy"
                        isOpen={popoverOpen}
                        toggle={toggle}
                    >
                        <PopoverBody>
                            <div className="form-group mb-3">
                                <label>Filter</label>
                                <select className='form-control' onChange={handleFilterChange} value={selectedFilter}>
                                    <option value="">Select an option</option>
                                    <option value="RECEIVED">Received Referral</option>
                                    <option value="SENT">Sent Referral</option>
                                </select>
                            </div>
                            <div className='text-center'><button className="btn nex-btn-primary round-lg" onClick={applyFilter}>Apply</button></div>
                        </PopoverBody>
                    </UncontrolledPopover>
                </div>
            </div>
        </>
    )
}


ReferalsFilter.defaultProps = {
    isTitle: true
}

export default ReferalsFilter;